import { all, fork } from 'redux-saga/effects';

import { showPendingAndSuccessToastrs } from './sagas/showPendingAndSuccessToastrs';

export default function* root() {
    yield all([fork(showPendingAndSuccessToastrs)]);
}
